import { useEffect, useState } from "react";
import MainLayout from "../components/MainLayout";
import GridPage from "../components/GridPage";
import {
  consumablesExcelExportHeader,
  consumablesHeader,
  contraceptiveExcelExportHeader,
  contraceptiveHeader,
  medicinesDrugsExcelExportHeader,
  medicinesDrugsHeader,
  socialMarketingExcelExportHeader,
  socialMarketingHeader,
} from "../components/HeaderAttribute";
import AddScreenTitle from "../components/AddScreenTitle";
import { mainTable } from "../css/Common";
import Buttons from "../components/Buttons";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import InputText from "../ReusableComponents/InputText";
import { useLocation } from "react-router-dom";
import {
  BindAPI,
  IUDAPI,
  LanguageTranslatorAPI,
} from "../services/APIConnection";
import toast from "react-hot-toast";
import MainPopup from "../popup-containers/MainPopup";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import Commoditiespopup from "../popup-containers/Commodities";
import PopUpButtons from "../components/PopUpButtons";
import ErrorPopup from "../ReusableComponents/ErrorPopup";
import Loader from "../ReusableComponents/Loader";
import * as XLSX from "sheetjs-style";
const Commodities = () => {
  //visiable state handle
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [visibleMode, setVisibleMode] = useState(false);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  // const [visibleTable1, setVisibleTable1] = useState(false);
  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);
  const [tableTitle, setTableTitle] = useState("");
  const [addTitle, setAddTitle] = useState("");
  const [commodityType, setCommodityType] = useState("");
  const [tableHeader, setTableHeader] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [commodityTypeState, setCommodityTypeState] = useState(0);
  //location path handle states
  const location = useLocation();

  //commodities dropdown state handle
  const [commoditiesCategories, setCommoditiesCategories] = useState([]);
  const [commoditiesCategoriesLabel, setCommoditiesCategoriesLabel] =
    useState("");
  const [bindModeDD, setBindModeDD] = useState([]);
  const [bindUnitOfMeasure, setBindUnitOfMeasure] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  //text filed state handle
  const [categoriesNameFiled, setCategoriesNameFiled] = useState("");

  //handle payload state
  const [mstCommoditiesId, setMstCommoditiesId] = useState("");
  const [commoditiesFileds, setCommoditiesFileds] = useState({
    categories: "",
    name: "",
    description: "",
    mode: "",
    mstCommodityUOMId: "",
    sdpLevel: "",
    outreachLevel: "",
    branchLevel: "",
    itemCategory: "",
  });

  const [commoditiesFieldsError, setCommoditiesFieldsError] = useState({
    categoriesError: "",
    nameError: "",
    descriptionError: "",
    modeError: "",
    openingQuantityError: "",
    unitOfMeasureError: "",
    openingDateError: "",
    chargesError: "",
    sdpLevelError: "",
    outreachLevelError: "",
    branchLevelError: "",
  });

  //popup state handle
  const [popUpOpen, setpopUpOpen] = useState(false);
  const [viewDetails, setViewDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [rowIndex, setRowIndex] = useState("");
  const [textFiledsPopupData, setTextFiledsPopupData] = useState([]);
  const [autoCompleteDropDownPopupData, setAutoCompleteDropDownPopupData] =
    useState({});

  const [isOpen, setIsOpen] = useState(false);

  const showAdd = () => {
    setVisibleTable(false);
    setVisibleAdd(true);
    setAddScreenTitle(true);
    setUpdateScreenTitle(false);
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().split("T")[0];

    setCommoditiesFileds((prevFields) => ({
      ...prevFields,
      openingDate: formattedDate,
    }));
  };

  // ✅ Generic API fetch helper
  const fetchTableData = async (endpoint, mapper, filterFn) => {
    try {
      const response = await BindAPI(endpoint);
      const table = response?.data?.Table ?? [];

      // Optional filtering
      const filtered = filterFn ? table.filter(filterFn) : table;

      // Optional mapping
      return mapper ? filtered.map(mapper) : filtered;
    } catch (error) {
      console.error(`❌ Error fetching ${endpoint}:`, error);
      return [];
    }
  };

  // ✅ Grid data binding
  const bindGridData = async (fetchData) => {
    setIsLoading(true);
    const gridData = await fetchTableData(
      "CommoditiesAPI/BindCommodities",
      null, // no mapper, keep raw objects
      (item) => item.MstCommodityTypeId === fetchData // filter condition
    );
    setTableData(gridData);
    setIsLoading(false);
  };

  const cancel = async () => {
    setVisibleAdd(false);
    setVisibleTable(true);
    clear();
    setpopUpOpen(false);
    setSubmitBtnDisabled(false);
    bindGridData(commodityTypeState);
    setIsLoading(false);
  };

  const clear = () => {
    setCommoditiesFileds({
      categories: "",
      name: "",
      description: "",
      mode: "",
      mstCommodityUOMId: "",
      sdpLevel: "",
      outreachLevel: "",
      branchLevel: "",
    });

    setCommoditiesFieldsError({
      categoriesError: "",
      nameError: "",
      descriptionError: "",
      modeError: "",
      unitOfMeasureError: "",
      sdpLevelError: "",
      outreachLevelError: "",
      branchLevelError: "",
    });
  };

  // ✅ Dropdown: Unit of Measure
  const getCommodityUOMDDValues = async () => {
    const values = await fetchTableData(
      "CommoditiesAPI/BindCommodityUOM",
      (item) => ({
        value: item.MstCommodityUOMId,
        label: item.CommodityUOM,
      })
    );
    setBindUnitOfMeasure(values);
  };

  // ✅ Dropdown: Mode
  const getModeDDValues = async () => {
    const values = await fetchTableData("CommoditiesAPI/BindMode", (item) => ({
      value: item.MstModeId,
      label: item.ModeName,
    }));
    setBindModeDD(values);
  };

  // ✅ Dropdown: Categories
  const categoriesDropDown = async (fetchData) => {
    const values = await fetchTableData(
      "CommoditiesAPI/BindCommodityCategory",
      (item) => ({
        value: item.MstCommodityCategoryId,
        label: item.CommodityCategory_en,
      }),
      (item) => item.MstCommodityTypeId === fetchData // filter
    );
    setCommoditiesCategories(values);
  };

  useEffect(() => {
    if (location.pathname == "/contraceptive") {
      setTableTitle("Contraceptive items");
      setAddTitle("Contraceptive items");
      setCommodityType(1);
      setTableHeader(contraceptiveHeader);
      bindGridData(1);
      categoriesDropDown(1);
      setCommoditiesCategoriesLabel("Contraceptive items Categories");
      setCategoriesNameFiled("Contraceptive items");
      setCommodityTypeState(1);
      setVisibleAdd(false);
      setVisibleTable(true);
      setVisibleMode(false);
      clear();
    } else if (location.pathname == "/medicinesdrugs") {
      setTableTitle("Medicines / Drugs");
      setAddTitle("Medicines / Drugs");
      setCommodityType(2);
      setTableHeader(medicinesDrugsHeader);
      bindGridData(2);
      categoriesDropDown(2);
      setCommoditiesCategoriesLabel("Medicines / Drugs Categories");
      setCategoriesNameFiled("Medicines Name");
      getModeDDValues();
      setCommodityTypeState(2);
      setVisibleAdd(false);
      setVisibleTable(true);
      setVisibleMode(true);
      clear();
    } else if (location.pathname == "/socialmarketing") {
      setTableTitle("Social Marketing");
      setAddTitle("Social Marketing");
      setCommodityType(3);
      setTableHeader(socialMarketingHeader);
      bindGridData(3);
      categoriesDropDown(3);
      setCommoditiesCategoriesLabel("Social Marketing Categories");
      setCategoriesNameFiled("Social Marketing Name");
      setCommodityTypeState(3);
      setVisibleAdd(false);
      setVisibleTable(true);
      setVisibleMode(false);
      clear();
    } else if (location.pathname == "/consumables") {
      setTableTitle("Consumables");
      setAddTitle("Consumables");
      setCommodityType(4);
      setTableHeader(consumablesHeader);
      bindGridData(4);
      categoriesDropDown(4);
      setCommoditiesCategoriesLabel("Consumables Categories");
      setCategoriesNameFiled("Consumables Name");
      setCommodityTypeState(4);
      setVisibleAdd(false);
      setVisibleTable(true);
      setVisibleMode(false);
      clear();
    }
    getCommodityUOMDDValues();
  }, [location.pathname ? location.pathname : null]);
  useEffect(() => {
    if (
      location.pathname == "/contraceptive" ||
      location.pathname == "/medicinesdrugs" ||
      location.pathname == "/socialmarketing" ||
      location.pathname == "/consumables"
    ) {
      setAddScreenTitle(false);
      setVisibleTable(true);
      setVisibleAdd(false);
    }
  }, [location]);
  const handleCommoditiesFileds = (value, name) => {
    setCommoditiesFileds({
      ...commoditiesFileds,
      [name]: value,
    });
  };

  const validate = (flag, currentScreen) => {
    const errors = {};

    if (flag == 1 || flag == 2) {
      if (commoditiesFileds.categories == "") {
        errors.categories = `Select ${commoditiesCategoriesLabel}`;
      }

      // Validation logic for the contraceptiveFields.contraceptiveName input
      if (!commoditiesFileds.name.trim()) {
        errors.name = `Enter ${categoriesNameFiled}`;
      }

      // Validation logic for the Unit Of Measure input
      if (commoditiesFileds.mstCommodityUOMId == "") {
        errors.unitOfMeasure = "Select Unit Of Measure";
      }

      // Validation logic for the SDP Level input
      if (!commoditiesFileds.sdpLevel) {
        errors.sdpLevel = "Enter SDP Level";
      } else if (!/^\d+$/.test(commoditiesFileds.sdpLevel)) {
        errors.sdpLevel = "Only numbers allowed";
      }

      // Validation logic for the Outreach Level input
      if (!commoditiesFileds.outreachLevel) {
        errors.outreachLevel = "Enter Outreach Level";
      } else if (!/^\d+$/.test(commoditiesFileds.outreachLevel)) {
        errors.outreachLevel = "Only numbers allowed";
      }

      // Validation logic for the Branch Level input
      if (!commoditiesFileds.branchLevel) {
        errors.branchLevel = "Enter Branch Level";
      } else if (!/^\d+$/.test(commoditiesFileds.branchLevel)) {
        errors.branchLevel = "Only numbers allowed";
      }

      if (currentScreen == "2") {
        if (commoditiesFileds.mode == "") {
          errors.mode = "Select Mode";
        }
      }
    }

    setCommoditiesFieldsError({
      ...commoditiesFieldsError,
      categoriesError: errors.categories || "",
      nameError: errors.name || "",
      modeError: errors.mode || "",
      unitOfMeasureError: errors.unitOfMeasure || "",
      sdpLevelError: errors.sdpLevel || "",
      outreachLevelError: errors.outreachLevel || "",
      branchLevelError: errors.branchLevel || "",
    });

    return errors;
  };

  const handleSubmit = async (items, flag) => {
    setSubmitBtnDisabled(true);
    setIsLoading(true);

    const commoditiesValidation = validate(flag, commodityType);
    if (Object.keys(commoditiesValidation).length !== 0) {
      setIsOpen(true);
    }
    if (Object.keys(commoditiesValidation).length === 0) {
      setIsOpen(false);
      var createdBy = sessionStorage.getItem("createdBy");
      if (flag == 1 || flag == 2) {
        const languageKeys = [
          "ta", // Tamil
          "hi", // Hindi
          "mr", // Marathi
          "gu", // Gujarati
          "kn", // Kannada
          "ml", // Malayalam
          "te", // Telugu
          "bn", // Bengali
          "or", // Oriya
        ];

        const commodityNametxt = [];

        const descriptiontxt = [];

        for (let i of languageKeys) {
          const translateText = await LanguageTranslatorAPI(
            commoditiesFileds.name,
            i
          );
          commodityNametxt.push(
            translateText.data.data.translations[0].translatedText
          );
        }

        for (let i of languageKeys) {
          const translateText = await LanguageTranslatorAPI(
            commoditiesFileds.description,
            i
          );
          descriptiontxt.push(
            translateText.data.data.translations[0].translatedText
          );
        }
        const commoditiesData = {
          mstCommoditiesID: mstCommoditiesId ? mstCommoditiesId : 0,
          mstCommodityTypeId: commodityType,
          mstCommodityCategoryId: commoditiesFileds.categories,
          commoditiesNameEn: commoditiesFileds.name,
          commoditiesNameTa: commodityNametxt[0],
          commoditiesNameHi: commodityNametxt[1],
          commoditiesNameMr: commodityNametxt[2],
          commoditiesNameGu: commodityNametxt[3],
          commoditiesNameKn: commodityNametxt[4],
          commoditiesNameMl: commodityNametxt[5],
          commoditiesNameTe: commodityNametxt[6],
          commoditiesNameBn: commodityNametxt[7],
          commoditiesNameOr: commodityNametxt[8],
          mode: commoditiesFileds.mode ? commoditiesFileds.mode : 0,
          descriptionEn: commoditiesFileds.description,
          descriptionTa: descriptiontxt[0],
          descriptionHi: descriptiontxt[1],
          descriptionMr: descriptiontxt[2],
          descriptionGu: descriptiontxt[3],
          descriptionKn: descriptiontxt[4],
          descriptionMl: descriptiontxt[5],
          descriptionTe: descriptiontxt[6],
          descriptionBn: descriptiontxt[7],
          descriptionOr: descriptiontxt[8],
          mstCommodityUOMId: commoditiesFileds.mstCommodityUOMId,
          commoditySDPLevel: commoditiesFileds.sdpLevel,
          commodityOutreachLevel: commoditiesFileds.outreachLevel,
          commodityBranchLevel: commoditiesFileds.branchLevel,
          createdBy: createdBy,
          flag: flag,
          itemCategory: commoditiesFileds.itemCategory,
        };

        const response = await IUDAPI(
          commoditiesData,
          "CommoditiesAPI/IUDCommodities"
        );
        if (flag == 1) {
          if (response.data.Table[0].result === "S") {
            toast.success(`${tableTitle} data added successfully 👍`, {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          } else {
            toast.error(`Failed to add ${tableTitle} data 👎`, {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          }
        } else if (flag == 2) {
          if (response.data.Table[0].result === "M") {
            toast.success(`${tableTitle} data updated successfully 👍`, {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          } else {
            toast.error(`Failed to update  ${tableTitle} data 👎`, {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          }
        } else {
          setSubmitBtnDisabled(false);
          setIsLoading(false);
        }
      } else {
        const commoditiesData = {
          mstCommoditiesID: tableData[items].MstCommoditiesId,
          createdBy: createdBy,
          flag: flag,
        };
        const response = await IUDAPI(
          commoditiesData,
          "CommoditiesAPI/IUDCommodities"
        );
        if (flag == 3) {
          // Delete
          if (response.data.Table[0].result === "D") {
            toast.success(` ${tableTitle} data deleted successfully 🗑️`, {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          } else {
            toast.error(`Failed to delete  ${tableTitle} data 👎`, {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          }
        } else if (flag == 4) {
          // Block
          if (response.data.Table[0].result === "B") {
            toast.success(` ${tableTitle} data blocked successfully 🚫`, {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          } else {
            toast.error(`Failed to block  ${tableTitle} data 👎`, {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          }
        } else if (flag == 5) {
          // Unblock
          if (response.data.Table[0].result === "UB") {
            toast.success(` ${tableTitle} data unblocked successfully ✅`, {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          } else {
            toast.error(`Failed to unblock  ${tableTitle} data 👎`, {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          }
        }
      }
    } else {
      setSubmitBtnDisabled(false);
      console.log("no all data here");
    }
  };

  const handleEdit = (rowIndex) => {
    setUpdateScreenTitle(true);
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(false);
    setCommoditiesFileds({
      ...commoditiesFileds,
      mode: tableData[rowIndex].Mode,
    });
    setCommoditiesFileds({
      ...commoditiesFileds,
      categories: tableData[rowIndex].MstCommodityCategoryId,
      name: tableData[rowIndex].CommodityName_en,
      description: tableData[rowIndex].Description_en,
      mstCommodityUOMId: tableData[rowIndex].MstCommodityUOMId,
      sdpLevel: tableData[rowIndex].CommoditySDPLevel,
      outreachLevel: tableData[rowIndex].CommodityOutreachLevel,
      branchLevel: tableData[rowIndex].CommodityBranchLevel,
      mode: tableData[rowIndex].Mode,
      itemCategory: tableData[rowIndex].ItemCategory,
    });
    setMstCommoditiesId(tableData[rowIndex].MstCommoditiesId);
  };
  const handleOpen = (isOpen) => {
    // Popup open
    setpopUpOpen(isOpen);
  };
  const handleClose = () => {
    setpopUpOpen(false); // Popup close
  };

  const handleCommoditiesDetails = (rowIndex, flag) => {
    console.log(rowIndex, flag);
    handleOpen(true);
    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
      setRowIndex(rowIndex);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
      setRowIndex(rowIndex);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setRowIndex(rowIndex);
      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setRowIndex(rowIndex);
      setUnBlockDetails(true);
    }

    const CategoriesrowData = tableData[rowIndex];
    const CategoriesInfo = commoditiesCategories.find(
      (CT) => CT.value == CategoriesrowData.MstCommodityCategoryId
    );
    const ResultCategories = [
      {
        value: CategoriesrowData.MstCommodityCategoryId,
        label: CategoriesInfo ? CategoriesInfo.label : "Unknown",
      },
    ];

    const UOMrowData = tableData[rowIndex];
    const UOMInfo = bindUnitOfMeasure.find((UM) => UM.value == UOMrowData.UOM);
    const ResultUOM = [
      {
        value: UOMrowData.UOM,
        label: UOMInfo ? UOMInfo.label : "Unknown",
      },
    ];

    const filterUOM = bindUnitOfMeasure.filter(
      (x) => x.value == tableData[rowIndex].MstCommodityUOMId
    );

    const moderowData = tableData[rowIndex];
    const modeInfo = bindModeDD.find((UM) => UM.value == moderowData.Mode);
    const ResultMode = [
      {
        value: moderowData.Mode,
        label: modeInfo ? modeInfo.label : "Unknown",
      },
    ];

    const dropdownDatas = [ResultCategories, filterUOM, ResultMode];
    setAutoCompleteDropDownPopupData(dropdownDatas);
    setTextFiledsPopupData(tableData[rowIndex]);
  };
  const handleExport = async () => {
    const locationResponse = await BindAPI("CommoditiesAPI/ExcelExportCommodities");

    let header = [];
    let filteredData = [];

    if (location.pathname === "/contraceptive") {
      header = contraceptiveExcelExportHeader;
      filteredData = locationResponse.data.Table.filter(
        (item) => Number(item.MstCommodityTypeId) === 1
      );
    }
    else if (location.pathname === "/medicinesdrugs") {
      header = medicinesDrugsExcelExportHeader;
      filteredData = locationResponse.data.Table.filter(
        (item) => Number(item.MstCommodityTypeId) === 2
      );
    }
    else if (location.pathname === "/socialmarketing") {
      header = socialMarketingExcelExportHeader;
      filteredData = locationResponse.data.Table.filter(
        (item) => Number(item.MstCommodityTypeId) === 3
      );
    }
    else if (location.pathname === "/consumables") {
      header = consumablesExcelExportHeader;
      filteredData = locationResponse.data.Table.filter(
        (item) => Number(item.MstCommodityTypeId) === 4
      );
    }


    // ✅ EXPORT WITH LOCAL DATA (IMMEDIATE)
    exportData(
      header.map((column) => column.title),
      filteredData
    );
  };


  const exportData = (columns, rows) => {
    /* ================= TITLE ================= */
    const titleRow = [
      {
        v: tableTitle,
        s: {
          font: { bold: true, sz: 16 },
          alignment: { horizontal: "left" },
        },
      },
    ];

    /* ================= HEADER ================= */
    const headerRow = columns.map((column) => ({
      v: column,
      s: {
        fill: { fgColor: { rgb: "2D2D6E" } },
        font: { bold: true, color: { rgb: "FFFFFF" } },
        alignment: { horizontal: "left" },
      },
    }));

    const spacingRow = [{ v: "" }];

    /* ================= DATA ROWS ================= */
    const dataRows = rows.map((rowData, index) => {
      const isAlternateRow = index % 2 === 1;
      const baseStyle = isAlternateRow
        ? { fill: { fgColor: { rgb: "F0F0F0" } } }
        : {};

      const row = [
        { v: index + 1, s: { ...baseStyle, alignment: { horizontal: "left" } } },
        { v: rowData.MstCommoditiesId, s: { ...baseStyle, alignment: { horizontal: "left" } } },
        { v: rowData.CommodityCategory_en, s: { ...baseStyle, alignment: { horizontal: "left" } } },
        { v: rowData.CommodityName_en, s: { ...baseStyle, alignment: { horizontal: "left" } } },
        { v: rowData.CommodityName_ta, s: { ...baseStyle, alignment: { horizontal: "left" } } },
        { v: rowData.CommodityName_hi, s: { ...baseStyle, alignment: { horizontal: "left" } } },
        { v: rowData.CommodityName_mr, s: { ...baseStyle, alignment: { horizontal: "left" } } },
        { v: rowData.CommodityName_gu, s: { ...baseStyle, alignment: { horizontal: "left" } } },
        
        { v: rowData.CommodityName_kn, s: { ...baseStyle, alignment: { horizontal: "left" } } },
        { v: rowData.CommodityName_ml, s: { ...baseStyle, alignment: { horizontal: "left" } } },
        
        
        { v: rowData.CommodityName_te, s: { ...baseStyle, alignment: { horizontal: "left" } } },
        { v: rowData.CommodityName_bn, s: { ...baseStyle, alignment: { horizontal: "left" } } },
        { v: rowData.CommodityName_or, s: { ...baseStyle, alignment: { horizontal: "left" } } },

      ];

      // ✅ Mode column only for medicinesdrugs
      if (location.pathname === "/medicinesdrugs") {
        row.push({
          v: rowData.ModeName,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        });
      }

      row.push(
        { v: rowData.Description_en, s: { ...baseStyle, alignment: { horizontal: "left" } } },
        { v: rowData.Description_ta, s: { ...baseStyle, alignment: { horizontal: "left" } } },
        { v: rowData.Description_hi, s: { ...baseStyle, alignment: { horizontal: "left" } } },
        { v: rowData.Description_mr, s: { ...baseStyle, alignment: { horizontal: "left" } } },
        { v: rowData.Description_gu, s: { ...baseStyle, alignment: { horizontal: "left" } } },
       
        { v: rowData.Description_kn, s: { ...baseStyle, alignment: { horizontal: "left" } } },
        { v: rowData.Description_ml, s: { ...baseStyle, alignment: { horizontal: "left" } } },
        
        
        { v: rowData.Description_te, s: { ...baseStyle, alignment: { horizontal: "left" } } },
         { v: rowData.Description_bn, s: { ...baseStyle, alignment: { horizontal: "left" } } },
        { v: rowData.Description_or, s: { ...baseStyle, alignment: { horizontal: "left" } } },
        { v: rowData.CommodityUOM, s: { ...baseStyle, alignment: { horizontal: "left" } } },
        { v: rowData.ItemCategory, s: { ...baseStyle, alignment: { horizontal: "left" } } },
        { v: Number(rowData.CommoditySDPLevel || 0), s: { ...baseStyle, alignment: { horizontal: "right" }, numFmt: "0" } },
        { v: Number(rowData.CommodityOutreachLevel || 0), s: { ...baseStyle, alignment: { horizontal: "right" }, numFmt: "0" } },
        { v: Number(rowData.CommodityBranchLevel || 0), s: { ...baseStyle, alignment: { horizontal: "right" }, numFmt: "0" } },
        { v: rowData.CreatedPerson, s: { ...baseStyle, alignment: { horizontal: "left" } } }
      );

      return row;
    });

    /* ================= SHEET DATA ================= */
    const wsData = [
      titleRow,
      spacingRow,
      headerRow,
      ...dataRows,
    ];

    const ws = XLSX.utils.aoa_to_sheet(wsData);

    /* ================= COLUMN WIDTHS ================= */
    const cols = [
      { width: 5 },   // S.No
      { width: 30 },  // Commodity Category
      { width: 30 },  // Commodity Category
      { width: 40 },  // Commodity Name
      { width: 40 },  // Commodity Name
      { width: 40 },  // Commodity Name
      { width: 40 },  // Commodity Name
      { width: 40 },  // Commodity Name
      { width: 40 },  // Commodity Name
      { width: 40 },  // Commodity Name
      { width: 40 },  // Commodity Name
      { width: 40 },  // Commodity Name
      { width: 40 },  // Commodity Name
    ];

    if (location.pathname === "/medicinesdrugs") {
      cols.push({ width: 20 }); // Mode
    }

    cols.push(
      { width: 50 },  // Description
      { width: 50 },  // Description
      { width: 50 },  // Description
      { width: 50 },  // Description
      { width: 50 },  // Description
      { width: 50 },  // Description
      { width: 50 },  // Description
      { width: 50 },  // Description
      { width: 50 },  // Description
      { width: 50 },  // Description
      { width: 20 },  // UOM
      { width: 20 },  // Item Category
      { width: 15 },  // SDP Level
      { width: 20 },  // Outreach Level
      { width: 20 },  // Branch Level
      { width: 35 }   // Created Person
    );

    ws["!cols"] = cols;

    /* ================= ROW HEIGHTS ================= */
    ws["!rows"] = [
      { hpt: 30 },
      { hpt: 15 },
      { hpt: 18 },
      ...Array(rows.length).fill({ hpt: 15 }),
    ];

    /* ================= BORDERS ================= */
    const applyStyles = (worksheet) => {
      const range = XLSX.utils.decode_range(worksheet["!ref"]);
      for (let R = range.s.r; R <= range.e.r; R++) {
        for (let C = range.s.c; C <= range.e.c; C++) {
          const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
          if (!worksheet[cellRef]) continue;

          worksheet[cellRef].s = {
            ...worksheet[cellRef].s,
            border: {
              top: { style: "thin", color: { rgb: "000000" } },
              bottom: { style: "thin", color: { rgb: "000000" } },
              left: { style: "thin", color: { rgb: "000000" } },
              right: { style: "thin", color: { rgb: "000000" } },
            },
          };
        }
      }
    };

    applyStyles(ws);

    /* ================= EXPORT ================= */
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, `${tableTitle}.xlsx`);
  };

  return (
    <MainLayout pageName={"2"}>
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {visibleTable && (
        <GridPage
          title={tableTitle}
          header={tableHeader}
          records={tableData ? tableData : []}
          handleEdit={handleEdit}
          handleAction={handleCommoditiesDetails}
          showAdd={showAdd}
          blockView={true}
          handleExport={handleExport}
          handleExportBtn={true}
        />
      )}
      {visibleAdd && (
        <div className="flex flex-col w-full">
          <div className={mainTable.mainAddScreen}>
            <AddScreenTitle
              addScreenTitle={addScreenTitle}
              updateScreenTitle={updateScreenTitle}
              title={addTitle}
            />
            <div className={mainTable.addShadowScreen}>
              <div className={mainTable.mainContentScreen}>
                <form className={mainTable.formForClientMaster}>
                  <div className={mainTable.grid3}>
                    <AutoDropDown
                      classStar="text-red-500"
                      title={commoditiesCategoriesLabel}
                      options={commoditiesCategories}
                      placeholder="Select"
                      Class="p-0"
                      name="categories"
                      selectedOption={commoditiesCategories.find(
                        (x) => x.value == commoditiesFileds.categories
                      )}
                      controlFunc={(value, e) => {
                        handleCommoditiesFileds(value.value, e.name);
                      }}
                      controlFuncBlur={() => {
                        setCommoditiesFieldsError({
                          ...commoditiesFieldsError,
                          categoriesError: commoditiesFileds.categories
                            ? ""
                            : `Select ${commoditiesCategoriesLabel}`,
                        });
                      }}
                      errorMessage={commoditiesFieldsError.categoriesError}
                    />

                    <div>
                      <InputText
                        classStar="text-red-500"
                        inputType="text"
                        title={categoriesNameFiled}
                        placeholder={
                          location.pathname === "/contraceptive"
                            ? "Contraceptive Name"
                            : location.pathname === "/medicinesdrugs"
                              ? "Medicines Drugs Name"
                              : location.pathname === "/socialmarketing"
                                ? "Social Marketing Name"
                                : location.pathname === "/consumables"
                                  ? "Consumables Name"
                                  : ""
                        }
                        name="name"
                        maxLength={200}
                        content={commoditiesFileds.name}
                        controlFunc={(e) => {
                          setCommoditiesFileds({
                            ...commoditiesFileds,
                            name: e.target.value,
                          });
                        }}
                        controlFuncBlur={() => {
                          setCommoditiesFieldsError(
                            (commoditiesFieldsError) => ({
                              ...commoditiesFieldsError,
                              nameError:
                                commoditiesFileds.name.length > 0
                                  ? ""
                                  : `Enter ${categoriesNameFiled}`,
                            })
                          );
                        }}
                        errorMessage={commoditiesFieldsError.nameError}
                      />
                    </div>
                    {visibleMode && (
                      <AutoDropDown
                        classStar="text-red-500"
                        title={"Route"}
                        options={bindModeDD}
                        placeholder="Select"
                        Class="p-0"
                        name="mode"
                        selectedOption={bindModeDD.find(
                          (x) => x.value == commoditiesFileds.mode
                        )}
                        controlFunc={(value, e) => {
                          handleCommoditiesFileds(value.value, e.name);
                        }}
                        controlFuncBlur={() => {
                          setCommoditiesFieldsError({
                            ...commoditiesFieldsError,
                            modeError: commoditiesFileds.mode
                              ? ""
                              : `Select Mode`,
                          });
                        }}
                        errorMessage={commoditiesFieldsError.modeError}
                      />
                    )}

                    <InputText
                      inputType="text"
                      title="Description"
                      placeholder="Description"
                      name="description"
                      maxLength={500}
                      content={commoditiesFileds.description}
                      controlFunc={(e) => {
                        setCommoditiesFileds({
                          ...commoditiesFileds,
                          description: e.target.value,
                        });
                      }}
                    />
                    <AutoDropDown
                      classStar="text-red-500"
                      title="Unit Of Measure"
                      options={bindUnitOfMeasure}
                      placeholder="Select"
                      Class="p-0"
                      name="mstCommodityUOMId"
                      selectedOption={bindUnitOfMeasure.find(
                        (x) => x.value == commoditiesFileds.mstCommodityUOMId
                      )}
                      controlFunc={(value, e) => {
                        handleCommoditiesFileds(value.value, e.name);
                      }}
                      controlFuncBlur={() => {
                        setCommoditiesFieldsError((commoditiesFieldsError) => ({
                          ...commoditiesFieldsError,
                          unitOfMeasureError:
                            commoditiesFileds.mstCommodityUOMId
                              ? ""
                              : `Select Unit Of Measure`,
                        }));
                      }}
                      errorMessage={commoditiesFieldsError.unitOfMeasureError}
                    />
                    {addTitle === "Contraceptive items" && (
                      <InputText
                        inputType="text"
                        title="Item Category"
                        placeholder="Item Category"
                        name="itemCategory"
                        maxLength={100}
                        content={commoditiesFileds.itemCategory}
                        controlFunc={(e) => {
                          setCommoditiesFileds({
                            ...commoditiesFileds,
                            itemCategory: e.target.value,
                          });
                        }}
                      />
                    )}

                    <div className="col-span-2">
                      <div className="grid gap-4 md:grid-cols-3 sm:col-span-1"></div>
                    </div>
                    <div className="col-span-3">
                      <div class={mainTable.labelBold}>Re-Order Level</div>
                      <hr class={mainTable.horizontalLine}></hr>
                    </div>
                    <div>
                      <InputText
                        classStar="text-red-500"
                        inputType="text"
                        title=" SDP Level"
                        placeholder="100"
                        name="sdpLevel"
                        maxLength={6}
                        content={commoditiesFileds.sdpLevel}
                        controlFunc={(e) => {
                          setCommoditiesFileds({
                            ...commoditiesFileds,
                            sdpLevel: e.target.value,
                          });
                        }}
                        controlFuncBlur={() => {
                          setCommoditiesFieldsError(() => ({
                            ...commoditiesFieldsError,
                            sdpLevelError: commoditiesFileds.sdpLevel
                              ? /^\d+$/.test(commoditiesFileds.sdpLevel)
                                ? ""
                                : "Only numbers allowed"
                              : "Enter SDP Level",
                          }));
                        }}
                        errorMessage={commoditiesFieldsError.sdpLevelError}
                      />
                    </div>
                    <div>
                      <InputText
                        classStar="text-red-500"
                        inputType="text"
                        title=" Outreach level"
                        placeholder="200"
                        name="outreachLevel"
                        maxLength={6}
                        content={commoditiesFileds.outreachLevel}
                        controlFunc={(e) => {
                          setCommoditiesFileds({
                            ...commoditiesFileds,
                            outreachLevel: e.target.value,
                          });
                        }}
                        controlFuncBlur={() => {
                          setCommoditiesFieldsError(() => ({
                            ...commoditiesFieldsError,
                            outreachLevelError: commoditiesFileds.outreachLevel
                              ? /^\d+$/.test(commoditiesFileds.outreachLevel)
                                ? ""
                                : "Only numbers allowed"
                              : "Enter Outreach level",
                          }));
                        }}
                        errorMessage={commoditiesFieldsError.outreachLevelError}
                      />
                    </div>
                    <div>
                      <InputText
                        classStar="text-red-500"
                        inputType="text"
                        title=" Branch level"
                        placeholder="300"
                        name="branchLevel"
                        maxLength={6}
                        content={commoditiesFileds.branchLevel}
                        controlFunc={(e) => {
                          setCommoditiesFileds({
                            ...commoditiesFileds,
                            branchLevel: e.target.value,
                          });
                        }}
                        controlFuncBlur={() => {
                          setCommoditiesFieldsError(() => ({
                            ...commoditiesFieldsError,
                            branchLevelError: commoditiesFileds.branchLevel
                              ? /^\d+$/.test(commoditiesFileds.branchLevel)
                                ? ""
                                : "Only numbers allowed"
                              : "Enter Branch level",
                          }));
                        }}
                        errorMessage={commoditiesFieldsError.branchLevelError}
                      />
                    </div>
                  </div>
                </form>
                <Buttons
                  addScreenTitle={addScreenTitle}
                  updateScreenTitle={updateScreenTitle}
                  handleSubmit={handleSubmit}
                  cancel={cancel}
                  disabledBtn={submitBtnDisabled ? true : false}
                />
              </div>
            </div>
          </div>
        </div>
      )}
      {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={handleCommoditiesDetails}
      >
        <div className=" flex flex-col gap-3">
          <PopUpScreenTitle
            title={tableTitle}
            setpopUpOpen={handleClose}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />
          <Commoditiespopup
            data={textFiledsPopupData}
            data2={autoCompleteDropDownPopupData}
          />
        </div>
        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          rowIndex={rowIndex}
          handleSubmit={handleSubmit}
          cancel={cancel}
          disabledBtn={submitBtnDisabled ? true : false}
        />
      </MainPopup>
    </MainLayout>
  );
};

export default Commodities;
